import type { OilPhaseVolumeFactorBoCalculator } from "../../d";
import { oilPhaseVolumeFactorCalculator as vasquezBeggs } from "../vasquezBeggs";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    const {
      gasSpecificGravity,
      oilAPI,
      temperatureInRankine,
      inSituPressurePSIA,
      oilSpecificGravity,
      temperatureF,
      bubblePointPressurePSIA,
      solutionGasRsoInSitu,
      gasOilRatio
    } = params;

    // D134: =(J12*(D8/D17)^0.526)+0.986*D4
    const correlatingParameterBob =
      solutionGasRsoInSitu *
        (gasSpecificGravity / oilSpecificGravity) ** 0.526 +
      0.986 * temperatureF;
    // D136: =1+10^(-6.58511+2.91329*LOG10(D134)-0.27683*(LOG10(D134))^2)
    const oilFormationVolumeFactorSatBo =
      1 +
      10 **
        (-6.58511 +
          2.91329 * Math.log10(correlatingParameterBob) -
          0.27683 * Math.log10(correlatingParameterBob) ** 2);
    // D138: =2.8869-(14.1811-3.3093*LOG10(J18))^0.5
    const aatpB =
      2.8869 - (14.1811 - 3.3093 * Math.log10(bubblePointPressurePSIA)) ** 0.5;
    // D140: =D8*(((D7^0.989)/(D4^0.172))*10^D138)^1.2255
    let solutionGasPbRsb =
      gasSpecificGravity *
      ((oilAPI ** 0.989 / temperatureF ** 0.172) * 10 ** aatpB) ** 1.2255;
    solutionGasPbRsb =
      solutionGasPbRsb > gasOilRatio ? gasOilRatio : solutionGasPbRsb;

    // D142: =(D140*(D8/D17)^0.526)+0.986*D4
    const correlatingParameterAtPbBob =
      solutionGasPbRsb * (gasSpecificGravity / oilSpecificGravity) ** 0.526 +
      0.986 * temperatureF;
    // D144: =1+10^(-6.58511+2.91329*LOG10(D142)-0.27683*(LOG10(D142))^2)
    const oilFormationVolumeFactoratPbBob =
      1 +
      10 **
        (-6.58511 +
          2.91329 * Math.log10(correlatingParameterAtPbBob) -
          0.27683 * Math.log10(correlatingParameterAtPbBob) ** 2);

    // GLASO DEPENDS ON VASQUEZ-BEGGS CALCULATIONS FOR normalizedGasSGYgn and solutionGasPbRsb
    // THIS IS THE ONLY INSTANCE WHERE ONE METHOD DIRECTLY CALLS ANOTHER
    const { rsc1, rsc2, rsc3, normalizedGasSGYgn } =
      vasquezBeggs.solutionGasRsoCalculator(params);
    // D43: D28*D25*(P15^D29)*EXP(D30*(D7/D13))
    // NOTE: THIS IS A VASQUEZ-BEGGS FIELD THAT IS BEING CALCUALATED HERE AS IT IS THE ONLY BO FIELD NEEDED IN ANOTHER METHOD
    const solutionGasatPbRsbVasquezBeggs =
      rsc1 *
      normalizedGasSGYgn *
      bubblePointPressurePSIA ** rsc2 *
      Math.exp(rsc3 * (oilAPI / temperatureInRankine));
    // END VASQUEZ-BEGGS CALCS

    // D146: =(-1433+5*D43+17.2*D15-1180*D30+12.61*D7)/((10^5)*D3)
    const oilCompressibilityUnSatCo =
      (-1433 +
        5 * solutionGasatPbRsbVasquezBeggs +
        17.2 * temperatureInRankine -
        1180 * normalizedGasSGYgn +
        12.61 * oilAPI) /
      (10 ** 5 * inSituPressurePSIA);
    // D148: =D144*EXP(D146*(J18-D3))
    const oilFormationVolumeFactorUnSatBo =
      oilFormationVolumeFactoratPbBob *
      Math.exp(
        oilCompressibilityUnSatCo *
          (bubblePointPressurePSIA - inSituPressurePSIA)
      );

    return {
      aatpB,
      solutionGasPbRsb,
      correlatingParameterAtPbBob,
      oilFormationVolumeFactoratPbBob,
      rsc1,
      rsc2,
      rsc3,
      normalizedGasSGYgn,
      solutionGasatPbRsbVasquezBegs: solutionGasatPbRsbVasquezBeggs,
      oilCompressibilityUnSatCo,
      oilFormationVolumeFactorSatBo,
      oilFormationVolumeFactorUnSatBo
    };
  };
